import { SIGN_OUT } from 'Global/Stores/auth'

const PREVIEW_MODAL_CURRENT_INDEX_SET = 'PREVIEW_MODAL/CURRENT_INDEX/SET'
const PREVIEW_MODAL_EXPANSION_TOGGLE = 'PREVIEW_MODAL/EXPANSION/TOGGLE'
const PREVIEW_MODAL_TOGGLE = 'PREVIEW_MODAL/TOGGLE'

export const previewModalCurrentIndexSet = index => {
  return {
    payload: index,
    type: PREVIEW_MODAL_CURRENT_INDEX_SET,
  }
}

export const previewModalExpansionToggle = index => {
  return {
    payload: index,
    type: PREVIEW_MODAL_EXPANSION_TOGGLE,
  }
}

export const makePreviewModalToggle = module => () => ({
  meta: { module },
  type: PREVIEW_MODAL_TOGGLE,
})

const defaulModuleState = {
  visible: false,
}

const initialState = {
  designerQueue: defaulModuleState,
  expanded: false,
  index: 0,
  markedForDesigners: defaulModuleState,
  myOrders: defaulModuleState,
  requestedRugs: defaulModuleState,
  search: defaulModuleState,
}

const reducer = (state = initialState, action) => {
  const { meta, payload, type } = action

  switch (type) {
    case PREVIEW_MODAL_CURRENT_INDEX_SET:
      return {
        ...state,
        index: payload,
      }

    case PREVIEW_MODAL_EXPANSION_TOGGLE:
      return {
        ...state,
        expanded: !state.expanded,
      }

    case PREVIEW_MODAL_TOGGLE:
      if (meta && meta.module) {
        return {
          ...state,
          [meta.module]: {
            ...state[meta.module],
            visible: !state[meta.module].visible,
          },
        }
      }

      return state

    case '@@router/LOCATION_CHANGE':
      return initialState

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
